export default class OnsiteRecommendationConstants {
  static TitleMaxLength = 60;
  static H1MaxLength = 60;
  static MetaDescriptionMaxLength = 160;
  static AltImageTagMaxLength = 125;
}